import React, { useState } from 'react';
import { SmlsButton, SmlsHeaderPlaceholder } from '@smiles/smiles-ui-kit-react';
import { useTranslation } from 'react-i18next';
import { getLink } from '../../utils';
import IconBrokenSuitcase from '../IconBrokenSuitcase';
import Header from '../header';

interface Params {
  type: 'BROKENSUITCASE';
  traduction?: string;
  onPrimary?: () => void;
  onClickErrorTreatment?: () => void;
}

const PageMessage: React.FC<Params> = ({ type, onClickErrorTreatment }) => {
  const { t } = useTranslation('PageMessage');

  const TypeMessage = {
    BROKENSUITCASE: IconBrokenSuitcase,
  };
  const CustomIcon = TypeMessage[type];

  return (
    <div className="wrapper">
      <Header />
      <div className="content-page">
        <div className="left-image">
          <CustomIcon />
        </div>
        <div className="right-message-container">
          <div className="right-info">
            <h3 className="title">{t('title')}</h3>
            <div className="description">
              <p className="subtitle">{t('subtitle')}</p>
            </div>

            <SmlsButton text={t('btn_primary')} onClick={onClickErrorTreatment} color="primary" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageMessage;
